import { Component, OnInit } from "@angular/core";
import { FuseTranslationLoaderService } from 'app/core/services/translation-loader.service';

import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { ResponseBase } from 'app/main/model/ResponseBase';
import { Settings } from 'app/main/model/Settings';
import { CalendarService } from 'app/main/pages/calendar/calendar.service';
import { ProjectofferService } from 'app/main/pages/project-offer/project-offer.service';
import { locale as danish } from "./translate/ds";
import { locale as english } from "./translate/en";

@Component({
    selector: 'Driving-amount',
    templateUrl: './driving-amount.component.html',
    styleUrls: ["./driving-amount.component.scss"]
})

export class DrivingAmountComponent implements OnInit {
    showSpinner: boolean = false;
    SettingsObj: Settings = new Settings();
    KMPerHoursSettingsObj: Settings = new Settings();
    travelingAmount: number = 0;
    settingMasterValues: any[] = [];
    DeserilizedValue: any;
    constructor(private translationLoaderService: FuseTranslationLoaderService,
        private translate: TranslateService,
        private projectofferService: ProjectofferService,
        public dialogRef: MatDialogRef<DrivingAmountComponent>,
        private calendarService: CalendarService,
        private notificationsService: NotificationsService) {
        this.translationLoaderService.loadTranslations(danish, english);
    }

    ngOnInit() {
        this.settingMasterValues = Object.assign([], JSON.parse(localStorage.getItem("settingMasterValues")));
        this.getTravelingDistancePerDayValue();
        this.getKilometerPerHoursValue();
    }

    getTravelingDistancePerDayValue() {
        this.showSpinner = true;
        this.projectofferService.GetDistancePerMinuteValue().subscribe((response: ResponseBase) => {
            if (response) {
                this.showSpinner = false;
                this.SettingsObj = response.result.myResponse[0];
            }
        },
            error => (err) => {
                this.showSpinner = false;
            });
    }

    getKilometerPerHoursValue() {
        this.showSpinner = true;
        this.projectofferService.GetKilometerPerHoursValue().subscribe((response: ResponseBase) => {
            if (response) {
                this.showSpinner = false;
                this.KMPerHoursSettingsObj = response.result.myResponse[0];
            }
        },
            error => (err) => {
                this.showSpinner = false;
            });
    }

    Update() {
        this.showSpinner = true;
        // this.DeserilizedValue.amount = this.travelingAmount ? this.travelingAmount : 0;
        // this.SettingsObj.value = JSON.stringify(this.DeserilizedValue);
        this.SettingsObj.value = String(this.SettingsObj.value ? this.SettingsObj.value : 0);
        this.calendarService.UpdateSettingValue<ResponseBase>(this.SettingsObj.id, this.SettingsObj)
            .subscribe(resonse => {
                if (resonse) {
                    this.showSpinner = false;
                    this.translate.get("MESSAGES.Success").subscribe({
                        next: (res) => {
                            this.notificationsService.success(res);
                        },
                        error: err => {
                        }
                    });
                    this.dialogRef.close(true)
                }
            },
                error => (err) => {
                    this.showSpinner = false;
                    this.translate.get("MESSAGES.Failed").subscribe({
                        next: (res) => {
                            this.notificationsService.error(res);
                        },
                        error: err => {
                        }
                    });
                });
    }

    UpdateKMPerHours() {
        this.showSpinner = true;
        this.KMPerHoursSettingsObj.value = String(this.KMPerHoursSettingsObj.value ? this.KMPerHoursSettingsObj.value : 0);
        this.calendarService.UpdateSettingValue<ResponseBase>(this.KMPerHoursSettingsObj.id, this.KMPerHoursSettingsObj)
            .subscribe(resonse => {
                if (resonse) {
                    this.showSpinner = false;
                    this.changeInLocalStorage(this.KMPerHoursSettingsObj.id, this.KMPerHoursSettingsObj)
                    this.translate.get("MESSAGES.Success").subscribe({
                        next: (res) => {
                            this.notificationsService.success(res);
                        },
                        error: err => {
                        }
                    });
                    this.dialogRef.close(true)
                }
            },
                error => (err) => {
                    this.showSpinner = false;
                    this.translate.get("MESSAGES.Failed").subscribe({
                        next: (res) => {
                            this.notificationsService.error(res);
                        },
                        error: err => {
                        }
                    });
                });
    }

    close() {
        this.dialogRef.close(false);
    }

    changeInLocalStorage(ID, new_obj) {
        if (this.settingMasterValues.find(obj => obj.id == ID)) {
            this.settingMasterValues.forEach((old_obj, index) => {
                if (old_obj.id == ID) {
                    this.settingMasterValues[index] = new_obj
                }
            })
        } else {
            this.settingMasterValues.push(new_obj)
        }
        localStorage.setItem("settingMasterValues", JSON.stringify(this.settingMasterValues));
    }
}